export function LoginPage() {
  return (
    <div className="min-h-screen bg-surface-950 flex items-center justify-center p-4">
      <div className="text-center max-w-sm">
        <div className="mb-8">
          <div className="flex items-center justify-center mb-4">
            <img
              src="/chartz_icon_dark.svg"
              alt="Chartz"
              className="w-24 h-24"
            />
          </div>
          <h1 className="text-3xl font-bold mb-2">Chartz</h1>
          <p className="text-gray-400">Create, organize, and share song charts with your band</p>
        </div>
        <a
          href="/api/login"
          className="inline-flex items-center justify-center gap-2 bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 px-8 rounded-xl transition-colors w-full"
        >
          Sign in with Replit
        </a>
        <p className="text-xs text-gray-500 mt-4">
          Free-form chart editing, personal versions, setlists, and offline support.
        </p>
      </div>
    </div>
  );
}
